<template>
    <div>
        <b-form-group class="mb-0" :state="false">
            <b-card :class="v.$invalid ? 'form-invalid' : 'form-valid'" no-body>
                <b-card-body>
                    <form-row-edit-text v-model="description" :v="v.supplier_reqs_a_text" label="Укажите, каким требованиям должен соответствовать участник закупки" compact label-class="my-0 py-0" />
                    <span class="ml-1 fs-14">Укажите, какими документами участник закупки должен подтвердить соответствие указанным требованиям:</span>
                    <b-table id="my-table" :fields="fields" :items="items" class="table-atmo mb-0" :class="{'form-invalid': v.supplier_reqs_a_documents.$invalid}" show-empty small responsive>
                        <template #head(actions)>
                            <action-button-small icon="plus-square" @click="addItem" title="Добавить описание документа" />
                        </template>
                        <template #cell(index)="data">
                            {{ data.index + 1 }}
                        </template>
                        <template #cell(description)="data">
                            <b-form-input v-model="data.item.description" class="mb-0 form-control fs-14" :class="!v.supplier_reqs_a_documents.$each[data.index].description.$invalid ? 'is-valid' : 'is-invalid'" />
                        </template>
                        <template #cell(actions)="data">
                            <action-button-small icon="trash" @click="removeItem(data.index)" title="Удалить" />
                        </template>
                        <template #empty>
                            <div class="w-100 text-center text-danger">Добавьте описание документа</div>
                        </template>
                    </b-table>
                </b-card-body>
            </b-card>
        </b-form-group>
    </div>
</template>

<script>

export default {
    name: 'supplier-requirement-supplier-reqs-a-edit-table',
    props: {
        value: {
            type: Object,
            required: true
        },
        v: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            fields: [
                { key: 'index', label: '№', tdClass: 'align-text-top text-nowrap py-1', thClass: 'py-1', thStyle: { width: '1px' } },
                { key: 'description', label: 'Описание документа', tdClass: 'align-text-top py-1 text-nowrap', thClass: 'py-1' },
                { key: 'actions', thStyle: 'width: 1px;', tdClass: 'text-right py-1', thClass: 'py-1' }
            ],
            showSignModal: false,
            signData: {
                signature: null,
                isCustomer: false
            }
        };
    },
    methods: {
        supplier_reqs_a_details(description, items) {
            return {
                supplier_reqs_a_text: description,
                supplier_reqs_a_documents: items
            }
        },
        addItem() {
            this.items.push({ description: null });
        },
        removeItem(index) {
            this.items.splice(index, 1);
        }
    },
    computed: {
        description: {
            get() {
                return this.value.supplier_reqs_a_text
            },
            set(value) {
                this.$emit('input', this.supplier_reqs_a_details(value, this.items));
            }
        },
        items: {
            get() {
                return this.value.supplier_reqs_a_documents
            },
            set(value) {
                this.$emit('input', this.supplier_reqs_a_details(this.description, value));
            }
        }
    }
};
</script>

<style scoped>
.form-invalid {
    border: 1px solid #dc3545;
}
.form-valid {
    border: 1px solid var(--green-color);
}
</style>
